import { useContext, useEffect, useMemo } from "react";
import { Route, Routes, HashRouter, useLocation } from "react-router-dom";

import Amplify from "aws-amplify";

import { AppContext } from "./contextProviders/AppContext";

import { LicenseInfo } from "@mui/x-license";
import Reservation from "./pages/Reservation";
import Confirmation from "./pages/Confirmation";
import MainPage from "./pages/MainPage";
import ReviewPage from "./pages/ReviewPage";
import ServiceProvider from "./pages/MainPageContent/ServiceProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { translation } from "./components/Dictionary";
import StepperComponent from "./pages/MainPageContent/StepperComponent";

{
  //Init Amplify from env variables (these fields are typically in aws-exports.js which is not available in this project)
  const awsconfig = {};
  const envPrefix = "REACT_APP_";
  const buildVariables = {
    REACT_APP_aws_project_region: process.env.REACT_APP_aws_project_region,
    REACT_APP_aws_appsync_graphqlEndpoint:
      process.env.REACT_APP_aws_appsync_graphqlEndpoint,
    REACT_APP_aws_appsync_region: process.env.REACT_APP_aws_appsync_region,
    REACT_APP_aws_appsync_authenticationType:
      process.env.REACT_APP_aws_appsync_authenticationType,
    REACT_APP_aws_appsync_apiKey: process.env.REACT_APP_aws_appsync_apiKey,
    REACT_APP_aws_user_files_s3_bucket:
      process.env.REACT_APP_aws_user_files_s3_bucket,
    REACT_APP_aws_user_files_s3_bucket_region:
      process.env.REACT_APP_aws_user_files_s3_bucket_region,
    REACT_APP_aws_cognito_identity_pool_id:
      process.env.REACT_APP_aws_cognito_identity_pool_id,
    REACT_APP_aws_cognito_region: process.env.REACT_APP_aws_cognito_region,
    REACT_APP_aws_user_pools_id: process.env.REACT_APP_aws_user_pools_id,
    REACT_APP_aws_user_pools_web_client_id:
      process.env.REACT_APP_aws_user_pools_web_client_id,
    REACT_APP_oauth: process.env.REACT_APP_oauth,
  };
  Object.entries(buildVariables).forEach(([key, value]) => {
    if (key.startsWith("REACT_APP_aws_")) {
      const awsKey = key.substring(envPrefix.length);
      awsconfig[awsKey] = value;
    } else if (key === "REACT_APP_oauth") {
      awsconfig["oauth"] = JSON.parse(value);
    }
  });

  Amplify.configure(awsconfig);
}

function AppRoutes() {
  return (
    <ScrollToTop>
      <Routes>
        <Route path="*" element={<MainPage />} />
        <Route element={<MainPage />}>
          <Route path="/" element={<StepperComponent />}>
            <Route path="/" element={<ServiceProvider />} />
          </Route>
        </Route>
        <Route exact path="/varaus" element={<Reservation />} />
        <Route path="/vahvistus" element={<Confirmation />} />
        <Route exact path="/palaute" element={<ReviewPage />} />
      </Routes>
    </ScrollToTop>
  );
}

function App() {
  const groups = window.URENT_APP_GROUPS;

  const { language, locale } = useContext(AppContext);
  const accommodationServiceLabel = {
    start: translation.get(language, "Daterange check-in date"),
    end: translation.get(language, "Daterange check-out date"),
  };
  const rentalServiceLabel = {
    start: translation.get(language, "Daterange pickup date"),
    end: translation.get(language, "Daterange return date"),
  };

  const FEATURE_DATERANGE_LABEL = useMemo(() => {
    if (!groups) return rentalServiceLabel;
    if (groups[0] === "gnista") {
      return accommodationServiceLabel;
    } else {
      return rentalServiceLabel;
    }
  }, [groups, language]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locale}
      localeText={FEATURE_DATERANGE_LABEL}
    >
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    </LocalizationProvider>
  );
}

// Mui X
LicenseInfo.setLicenseKey(
  "2a05a1d540293f031db1ad247bad60e5Tz0xMDEyNzMsRT0xNzYyNDIyMDM0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

export default App;

function ScrollToTop({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}
